import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency, formatDate } from "../utils/utils";
import { getPaymentDetails } from "../redux/reducers/userSlice";
import { baseUrl } from "../redux";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const Checkout = () => {
  const { userData } = useSelector((state) => state.auth);
  const { paymentDetails } = useSelector((state) => state.users);
  const { licenseFee, status, userId } = userData;
  const {
    lastPaymentDate,
    nextPaymentDate,
    paymentStatus,
    threeDaysRemainFlag,
  } = paymentDetails;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPaymentDetails(userId));
  }, [dispatch]);

  const handleCheckout = async () => {
    const response = await fetch(`${baseUrl}/create-checkout-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: licenseFee * 100,
        userId: userId.toString(),
      }), // Example amount in cents
    });

    const session = await response.json();
    const stripe = await stripePromise;

    const { error } = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (error) {
    }
  };

  const isUnpaid = paymentStatus === "Unpaid";
  const isOnTrial = paymentStatus === "Trial";

  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 gap-4">
        {paymentStatus === "Paid" && threeDaysRemainFlag && (
          <p className="text-red-500 font-bold underline text-xs sm:text-sm md:text-base">
            Your Account Will be Shut Down In 1 to 3 Days
          </p>
        )}
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
          <h1 className="text-2xl font-semibold text-center text-gray-800 mb-6  sm:text-sm md:text-base">
            Billing Information
          </h1>

          <div className="space-y-4">
            <div className="flex justify-between text-gray-700 text-xs sm:text-sm md:text-base">
              <span className="font-medium">Subscription Cost:</span>
              <span className="font-semibold text-lg">
                {formatCurrency(licenseFee || 0)}
              </span>
            </div>

            <div className="flex justify-between text-gray-700 text-xs sm:text-sm md:text-base">
              <span className="font-medium">Payment Status:</span>
              <span
                className={`font-semibold ${
                  paymentStatus === "Paid" ? "text-green-500" : "text-red-500"
                } `}
              >
                {paymentStatus}
              </span>
            </div>

            <div className="flex justify-between text-gray-700 text-xs sm:text-sm md:text-base">
              <span className="font-medium">Last Payment Date:</span>
              <span className="font-semibold text-gray-800">
                {lastPaymentDate ? formatDate(lastPaymentDate) : "-"}
              </span>
            </div>

            <div className="flex justify-between text-gray-700 text-xs sm:text-sm md:text-base">
              <span className="font-medium">Next Payment Date:</span>
              <span className="font-semibold text-gray-800">
                {nextPaymentDate ? formatDate(nextPaymentDate) : "-"}
              </span>
            </div>

            <div className="mt-6">
              <button
                onClick={handleCheckout}
                disabled={!isUnpaid && !isOnTrial && !threeDaysRemainFlag}
                className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 disabled:bg-gray-400 disabled:text-gray-50 text-xs sm:text-sm md:text-base"
              >
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Checkout;
